import { render, staticRenderFns } from "./SettingsDatatable.vue?vue&type=template&id=067933b7"
import script from "./SettingsDatatable.vue?vue&type=script&lang=js"
export * from "./SettingsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports